export const PERIODS = [
    { value: 'h', label: 'period.text.last-hour' },
    { value: '3h', label: 'period.text.last-3-hours' },
    { value: 'd', label: 'period.text.last-day' },
    { value: '3d', label: 'period.text.last-3-days' },
    { value: 'w', label: 'period.text.last-week' },
];

export const INVALID_VALUE = -1000;
